<script>
import $ from './utils/NodeList.js'

export default {
  props: {
    item: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: false
    }
  },

  computed: {
    classes () {
      return [{open: this.show, disabled: this.disabled}]
    },
    menu () {
      return ! this.$parent
    },
    submenu () {
      return this.$parent && (this.$parent.menu || this.$parent.submenu)
    }
  },
  methods: {
    blur () {
      this.unblur()
      this._hide = setTimeout(() => {
        this._hide = null
        this.show = false
      }, 100)
    },
    unblur () {
      if (this._hide) {
        clearTimeout(this._hide)
        this._hide = null
      }
    }
  },
  mounted () {
    const $el = $(this.$refs.dropdown)
    $el.onBlur((e) => { this.show = false })
    $el.findChildren('a,button').on('click', e => {
      e.preventDefault()
      if (this.disabled) { return false }
      this.show = !this.show
      return false
    })
    $el.findChildren('ul').on('click', 'li>a', e => { this.show = false })
  },
  beforeDestroy () {
    const $el = $(this.$refs.dropdown)
    $el.offBlur()
    $el.findChildren('a,button').off()
    $el.findChildren('ul').off()
  }
}
</script>

<style scoped>
.secret {
  position: absolute;
  clip: rect(0 0 0 0);
  overflow: hidden;
  margin: -1px;
  height: 1px;
  width: 1px;
  padding: 0;
  border: 0;
}
</style>
